import {Injectable} from '@angular/core';
import {AuthService, PageService} from '@gallaghercp/core-frontend';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {Observable, Subject} from 'rxjs';
import {map, take} from 'rxjs/operators';


@Injectable({
    providedIn: 'root'
})
export class ClientService implements CanActivate {

    DEFAULT = {
        name: 'Hub',
        login: 'Login',
        welcome: 'Welcome to Hub, login below',
        support: 'Need help signing in?',
        uid: 'UID',
        uidHelper: false,
        dobFormat: 'DD/MM/YYYY',
    };

    provider: any;
    tabIndex?: number;
    $languageChange: Subject<string> = new Subject<string>();
    currentSetLanguage: string = '';

    constructor(
        protected auth: AuthService,
        protected router: Router,
        protected pages: PageService,
    ) {
        // I've created an 'current Language' observable so that
        // we can swap out Cookie Policies on the fly because the two
        // JS files from DCR conflict with each other
        // this.$languageChange.subscribe((value) => {
        //     this.currentSetLanguage = value;
        // });
    }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        if (!this.auth.authResumed) {
            this.auth.resume();
        }
        return this.auth.isResumed.pipe(
            take(1),
            map(() => {
                if (this.auth.isAuthenticated()) {
                    return true;
                }
                if (this.getAccessType() === 'public' && state.url !== '/profile') {
                    return true;
                }
                this.router.navigate(['/login']);
                return false;
            })
        );
    }

    getConfiguration() {
        this.provider = this.auth.serviceProvider;
        return this.provider && this.provider.configuration ? this.provider.configuration : {};
    }

    getAccessType() {
        return this.getConfiguration().accessType || 'individual';
    }

    getLogoURL() {
        return this.getConfiguration().logo || 'https://storage.googleapis.com/archipelago-assets/TOPCOLOGO-GRADIENTWHITE%402x.svg';
    }

    getLogoInvertedURL() {
        return this.getConfiguration().logoInverted || this.getLogoURL();
    }

    getSiteName() {
        return this.getConfiguration().name || this.DEFAULT.name;
    }

    getTileIndex(): number {
        return this.tabIndex || 0;
    }

    setTileIndex(index: number) {
        this.tabIndex = index;
    }

}
